<template>
  <NewsletterForm :config="config" />
</template>

<script>
import NewsletterForm from "../../components/NewsletterForm/NewsletterForm.vue";

export default {
  name: "app",
  components: {
    NewsletterForm
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
